export const CONNECT_SOCKET = 'socket/CONNECT_SOCKET ';
export const DISCONNECT_SOCKET = 'socket/DISCONNECT_SOCKET';

export const SOCKET_CONNECTED = 'socket/SOCKET_CONNECTED ';
export const SOCKET_DISCONNECTED = 'socket/SOCKET_DISCONNECTED';

export const LOGIN_SOCKET = 'socket/LOGIN_SOCKET';

export function connectToServer() {
    return {type: CONNECT_SOCKET};
}

export function disconnectFromServer() {
    return {type: DISCONNECT_SOCKET};
}

export function loginSocket() {
    return {
        type: LOGIN_SOCKET,
        socketRequest: {
            event: 'app:login',
        },
    };
}



// WEBPACK FOOTER //
// ./src/reducers/socketConnection/socketConnectionActions.js